export default {
  loading: false,
  data: [],
  errors: [],
  error_msg: false,
};
